import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-permited',
  templateUrl: './not-permited.component.html',
  styleUrls: ['./not-permited.component.css']
})
export class NotPermitedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
